import { render, staticRenderFns } from "./VerifyBox.vue?vue&type=template&id=1ff953c0&scoped=true&"
import script from "./VerifyBox.vue?vue&type=script&lang=ts&"
export * from "./VerifyBox.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyBox.vue?vue&type=style&index=0&id=1ff953c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff953c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSkeletonLoader,VTextField})
